var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'wa--chart-panel wa--panel bx--aspect-ratio',
    `bx--aspect-ratio--${_vm.dimension}`
  ],style:(_vm.style)},[_vm._t("default",null,{"data":_vm.chartData,"options":_vm.chartOptions}),_c('hr',{staticClass:"wind--divider wind--divider--invisible wind--divider--subtle"}),_c('span',{staticClass:"wa--chart-panel--title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }